import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SEGMENT } from './app-routing.model';
import { AuthGuard } from '@core/auth.guard';
import { HomeGuard } from '@core/home.guard';
import { RemoveCardComponent } from '@core/remove-card/remove-card.component';
import { RemoveDownloadKeyComponent } from '@core/remove-download-key/remove-download-key.component';
import { GoodbyePageComponent } from '@core/goodbye-page';

const routes: Routes = [
	{
		path: '',
		redirectTo: SEGMENT.CONNECT,
		pathMatch: 'full'
	},
	{
		path: SEGMENT.CONNECT,
		loadChildren: () => import('app/modules/driver-card/driver-card.module').then(m => m.DriverCardModule)
	},
	{
		path: SEGMENT.HOME,
		loadChildren: () => import('app/modules/home/home.module').then(m => m.HomeModule),
		canActivate: [ AuthGuard, HomeGuard ]
	},
	{
		path: SEGMENT.REMOVE_CARD,
		component: RemoveCardComponent
	},
	{
		path: SEGMENT.REMOVE_DLK,
		component: RemoveDownloadKeyComponent
	},
	{
		path: SEGMENT.GOODBYE_PAGE,
		component: GoodbyePageComponent
	}
];

@NgModule( {
	imports: [ RouterModule.forRoot( routes ) ],
	providers: [ AuthGuard, HomeGuard ],
	exports: [ RouterModule ]
} )
export class AppRoutingModule { }
